import {Dimensions} from 'react-native';

export default function getRem() {
  let {height, width} = Dimensions.get('window');
  console.log('height', height);
  console.log('width', width);
  let rem = Math.max(width, height) / 100;
  // if (width / height > 1.8) {
  //   rem = width / 1.6 / 100;
  // }
  return {
    rem: rem,
    hRem: height / 100,
    width,
    height,
  };
}
